import { useAuth } from "../../hooks/useAuth";
import SocialButton from "../blocks/SocialButton";

const SocialSignUp = () => {
  const { federatedLogin, isLoading, clearError } = useAuth();
  const handleGoogleLogin = async () => {
    clearError();
    try {
      await federatedLogin("Google");
    } catch (err) {
      console.error("Google login error:", err);
    }
  };

  const handleAppleLogin = async () => {
    clearError();
    try {
      await federatedLogin("Apple");
    } catch (err) {
      console.error("Apple login error:", err);
    }
  };
  return (
    <div className="authentication__social vertical">
      <SocialButton
        type="google"
        onClick={handleGoogleLogin}
        text={"Continue with Google"}
        disabled={isLoading}
      />
      <SocialButton
        type="apple"
        onClick={handleAppleLogin}
        text={"Sign in with Apple"}
        disabled={isLoading}
      />
    </div>
  );
};

export default SocialSignUp;
